export const moduleName = 'axp-myca-root';
export const customLocales = ['en-TH', 'th-TH'];

export const clickToChat = {
  '/banking': 'cca',
  default: 'MYCA',
};

export const styleSheetHref = {
  vortexDls6: 'https://www.aexp-static.com/cdaas/dls-vortex-web/1.0.0/styles/dls.min.css',
  dls6: 'https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.24.0/package/dist/6.24.0/styles/dls.min.css',
  dls7: 'https://www.aexp-static.com/cdaas/dls/packages/@americanexpress/dls/7.5.0/stylesheets/dls-max.min.css',
};

// TODO: Remove this when product-ducks 1.4.x is ready to be installed
export const B2B_ONEAP = 'AEXP_B2B_ONEAP';
